import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Seguidores',
  steps: {
    upload: 'Carregar',
    validate: 'Confirmar',
    finish: 'Concluído',
  },
  labels: {
    import: 'Importar',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
